import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ec618f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Weiter")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Start")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_ion_row = _resolveComponent("ion-row")!

  return (_ctx.isNode)
    ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, {
            "size-xs": "6",
            "size-sm": "4",
            class: "center-vert",
            style: {"padding-left":"0"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "cursor-pointer back-button next-button center",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBack()))
              }, " < Zurück ")
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, {
            "size-xs": "0",
            "size-sm": "4",
            class: "center",
            style: {"padding":"0"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_progress_bar, {
                value: _ctx.progress,
                style: {"border-radius":"10px"}
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_ion_col, {
            "size-xs": "6",
            "size-sm": "4",
            style: {"padding-right":"0"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_button, {
                disabled: !_ctx.nextActive && _ctx.$route.name !== 'Slider',
                "next-button": "",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('next', $event))),
                "no-shadow": "",
                style: {"float":"right"}
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_ion_row, { key: 1 }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_col, { class: "center" }, {
            default: _withCtx(() => [
              _createVNode(_component_base_button, {
                "next-button": "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('second-page', $event))),
                "no-shadow": ""
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
}